import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.mindfulness.blog.heading',
		defaultMessage: 'More mindfulness resources on our blog.',
		description: 'Heading for a list of blog posts about mindfulness.',
	},
});
